import { useMutation, useQueryClient } from "@tanstack/react-query";
import { chatApi } from "../../api/chat";
import { AddMessageReactionBody } from "../../types/chat";

export const useAddReaction = (roomId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: AddMessageReactionBody) => chatApi.addMessageReaction(body),
    onSuccess: (_, variables) => {
      // Invalidate reactions trong phòng để refresh danh sách reactions
      queryClient.invalidateQueries({
        queryKey: ["reactions", "room", roomId],
      });

      // Invalidate reactions cho tin nhắn cụ thể để refresh hiển thị reaction
      queryClient.invalidateQueries({
        queryKey: ["reactions", "message", variables.MessageId],
      });
    },
    onError: (error) => {
      console.error("Lỗi khi thêm reaction:", error);
    },
  });
};
